import axios from "axios";
import React, { Component } from "react";
import AlertPopup from "./AlertPopup";
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';


class EnquiryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      fatherName: "",
      studentEmail: "",
      mobileNumber: "",
      whatsappNumber: "",
      dob: "",
      gender: "",
      address: "",
      city: '',
      state: '',
      pinCode: '',
      course: "",
      your_time: "",
      courseList: [],
      message: "",
      errors: {},
      showAlert: false,
      alertTitle: '',
      alertMessage: '',
      alertType: '', // success or error
      alertIcon: null,
    };
  }

  componentDidMount() {
    // try {
    //   const storedCourses = window.sessionStorage.getItem("courseList");
    //   if (storedCourses) {
    //     const courseList = JSON.parse(storedCourses);
    //     // console.log("Loaded Course List:", courseList);
    //     this.setState({ courseList });
    //   }
    // } catch (e) {
    //   console.error("Error loading courseList from localStorage:", e);
    // }
    const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    axios
      .post(`${BackendUrl}/course/multiple/1`)
      .then((response) => {
        const data = response.data.data.map(item => item.title.en);
        this.setState({ courseList: data });
      })
      .catch((error) => {
        console.error("Error fetching Courses:", error);
         this.setState({ courseList: [] });
      });
  }

  // Handle input changes
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  // Handle form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const {name,fatherName,studentEmail,mobileNumber,whatsappNumber,dob,gender,address,city,state,pinCode, course,your_time,} = this.state;
    // Check for empty fields
    const emptyFields = [];
    if (!name) emptyFields.push("Student Name");
    if (!fatherName) emptyFields.push("Father Name");
    if (!studentEmail) emptyFields.push("Student Email");
    if (!mobileNumber) emptyFields.push("Mobile Number");
    if (!whatsappNumber) emptyFields.push("WhatsApp Number");
    if (!dob) emptyFields.push("DOB");
    if (!gender) emptyFields.push("Gender");
    if (!address) emptyFields.push("Address");
    if (!city) emptyFields.push("City");
    if (!state) emptyFields.push("State");
    if (!pinCode) emptyFields.push("Pin Code");
    if (!course) emptyFields.push("Course");
    if (!your_time) emptyFields.push("Choose Your Timing");

    if (emptyFields.length > 0) {
      this.setState({
      showAlert: true,
      alertTitle: 'ERROR',
      alertMessage: `Please fill: ${emptyFields[0]}`,
      alertType: 'error',
      alertIcon: faTimesCircle,
      });
      return;
    }

    // Validate mobile number length
    if (!/^\d{10}$/.test(mobileNumber)) {
      this.setState({showAlert: true,alertTitle: 'ERROR',alertMessage: 'Mobile Number must be exactly 10 digits.',alertType: 'error',alertIcon: faTimesCircle,});
      return;
    }
    if (!/^\d{10}$/.test(whatsappNumber)) {
      this.setState({showAlert: true,alertTitle: 'ERROR',alertMessage: 'WhatsApp Number must be exactly 10 digits.',alertType: 'error',alertIcon: faTimesCircle,});
      return;
    }

    const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const requestBody = {
      name,
      f_name: fatherName,
      emailId: studentEmail,
      mobile: mobileNumber,
      whatsapp_no: whatsappNumber,
      dob,
      gender,
      address,
      city,
      state,
      pinCode,
      course,
      your_time,
    };

    axios
      .post(`${BackendUrl}/student-application`, requestBody)
      .then((response) => {
        // console.log("Message sent successfully:", response.data);
        // alert("Your Request Is Submitted");
        this.setState({
          name: "",
          fatherName: "",
          studentEmail: "",
          mobileNumber: "",
          whatsappNumber: "",
          dob: "",
          gender: "",
          address: "",
          city: '',
          state: '',
          pinCode: '',
          course: "",
          your_time: "",
          showAlert: true,
          alertTitle: 'SUCCESS',
          alertMessage: 'Your request has been submitted successfully.',
          alertType: 'success',
          alertIcon: faCheckCircle,
        });
      })
      .catch((error) => {
        console.error("Error sending message:", error);
        this.setState({
        showAlert: true,
        alertTitle: 'ERROR',
        alertMessage: 'Failed to send your request. Please try again later.',
        alertType: 'error',
        alertIcon: faTimesCircle,
      });
      });
  };

  render() {
    const {
      name,
      fatherName,
      studentEmail,
      mobileNumber,
      whatsappNumber,
      dob,
      gender,
      address,
      city,
      state,
      pinCode,
      course,
      your_time,
      courseList, alertTitle, alertMessage, alertIcon, alertType
    } = this.state;

    return (
      <div className="container-fluid contact py-3">
        <div className="container">
          <div
            className="text-center mx-auto mb-3"
            style={{ maxWidth: "700px" }}
          >
            <p className="fs-5 text-uppercase text-primary">
              Student Registration
            </p>
            <h1>We Are Providing Live Online Courses</h1>
          </div>
          <form onSubmit={this.handleSubmit}>
            <div className="row g-4 col-lg-10 m-auto shadow p-3 br-10">
              <div className="col-sm-6">
                <label className="mb-2 text-primary">Student Name</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  placeholder="Your Name"
                  name="name"
                  value={name}
                  onChange={this.handleChange}
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Father Name</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  placeholder="Father's Name"
                  name="fatherName"
                  value={fatherName}
                  onChange={this.handleChange}
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Student Email</label>
                <input
                  type="email"
                  className="form-control bg-transparent p-3"
                  placeholder="Your Email"
                  name="studentEmail"
                  value={studentEmail}
                  onChange={this.handleChange}
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Mobile Number</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  placeholder="Mobile Number"
                  name="mobileNumber"
                  value={mobileNumber}
                  onChange={this.handleChange}
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">WhatsApp Number</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  placeholder="WhatsApp Number"
                  name="whatsappNumber"
                  value={whatsappNumber}
                  onChange={this.handleChange}
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">DOB</label>
                <input
                  type="date"
                  className="form-control bg-transparent p-3"
                  name="dob"
                  value={dob}
                  onChange={this.handleChange}
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Gender</label>
                <select
                  className="form-select bg-transparent p-3"
                  name="gender"
                  value={gender}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Address</label>
                <textarea
                  rows={1}
                  className="form-control bg-transparent p-3"
                  placeholder="Your Address"
                  name="address"
                  value={address}
                  onChange={this.handleChange}
                ></textarea>
              </div>
              <div className="col-sm-6">
                <label className="mb-2 text-primary">City</label>
                <textarea
                  rows={1}
                  className="form-control bg-transparent p-3"
                  placeholder="Your City"
                  name="city"
                  value={city}
                  onChange={this.handleChange}
                ></textarea>
              </div>
              <div className="col-sm-6">
                <label className="mb-2 text-primary">State</label>
                <textarea
                  rows={1}
                  className="form-control bg-transparent p-3"
                  placeholder="Your State"
                  name="state"
                  value={state}
                  onChange={this.handleChange}
                ></textarea>
              </div>
              <div className="col-sm-6">
                <label className="mb-2 text-primary">Pin Code</label>
                <textarea
                  rows={1}
                  className="form-control bg-transparent p-3"
                  placeholder="Your Pin Code"
                  name="pinCode"
                  value={pinCode}
                  onChange={this.handleChange}
                ></textarea>
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Course</label>
                <select
                  className="form-select bg-transparent p-3"
                  name="course"
                  value={course}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  {courseList.map((course, index) => (
                    <option key={index} value={course}>
                      {course}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Choose Your Timing</label>
                <input
                  type="time"
                  className="form-control bg-transparent p-3"
                  name="your_time"
                  id=""
                  value={your_time}
                  onChange={this.handleChange}
                />
              </div>

              <div className="col-12 text-center my-4">
                <button
                  className="btn btn-primary border-0 py-3 px-5"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
           {/* Alert Popup */}
        {this.state.showAlert && (
          <AlertPopup
            title={alertTitle}
            message={alertMessage}
            icon={alertIcon}
            type={alertType}
            onClose={() => this.setState({ showAlert: false })}
          />
        )}
        </div>
      </div>
    );
  }
}

export default EnquiryPage;
